import React, { Fragment, useState } from 'react'
import styled from 'styled-components';
import { ConfirmIcon } from '../../components/Icons/ConfirmIcon';
import { Modal, ModalContent } from '../../components/Modal/Modal';
import { formatDisplay, formatDisplayShorthand } from '../../utils/formatDisplay';
import { useAccount } from 'wagmi';
import { Contract } from 'ethers/lib/ethers';
import { ErrorIcon } from '../../components/Icons/ErrorIcon';
import { BootyABI } from '../../constants/ABI/BootyABI';
import { BOOTY_ADDRESS } from '../../constants/addresses';
import { Spinner } from '../../components/Loaders';
import { itemsMap } from './Items';
import { addQuota } from '../../store/quotasSlice';
import { NavLink } from 'react-router-dom';
import { useAppDispatch } from '../../store/hooks';
import { breakpoints, Media } from '../../styles';
import { useWidthBreakpoint } from '../../hooks';
import { clearCurrentPoints, updateBoosts } from '@/store/pointsSlice';
import { useEthersProvider, useEthersSigner } from '@/utils/wagmi-ethers-adapters/ethers';

interface ConfirmActivateProps {
  visible: boolean,
  setVisible: (visible: boolean) => void,
  setActivateDisabled: (disabled: boolean) => void,
  activateAmounts: Record<string, string>,
  setActivateAmounts: (amounts: Record<string, string>) => void,
  currentBoost: number,
  activatedBoosters: { [booster: string]: number },
  quotaAmounts: Record<string, number>,
  update: () => void
}

export const ConfirmActivate = ({ visible, setVisible, setActivateDisabled, activateAmounts, setActivateAmounts, currentBoost, activatedBoosters, quotaAmounts, update }: ConfirmActivateProps) => {
  const isTablet = useWidthBreakpoint(breakpoints.tablet)
  const { address : walletAddress } = useAccount();
  const { data: signer } = useEthersSigner();
  const provider = useEthersProvider();
  
  const [confirmDisabled, setConfirmDisabled] = useState(false)
  const [txState, setTxState] = useState('')

  const booty = new Contract(BOOTY_ADDRESS, BootyABI, signer || provider)

  const boosters: {[id: string] : any} = {}
  const expanders: any[] = []

  Object.keys((activateAmounts)).forEach((artifactID: string) => {
    const artifact = itemsMap[parseInt(artifactID)]

      const artifactCopy: any = { ...artifact }

      if (artifact.effect) {
        if (artifactCopy.effect.type == 'Booster') {
          artifactCopy['totalEffect'] = (artifact.effect?.value ?? 0)
          boosters[artifactID] = artifactCopy
        } else {
          artifactCopy['totalEffect'] = parseInt(activateAmounts[artifactID]) * (artifact.effect?.value ?? 0)
          expanders.push(artifactCopy)
        }
      }
  })

  const rowLength = 5;
  const artifactRows = []

  for (let i = 0; i < Object.keys(activateAmounts).length; i += rowLength) {
    artifactRows.push(Object.keys(activateAmounts).slice(i, i + rowLength))
  }

  const randomBoost = Object.values(boosters).filter((booster) => booster.totalEffect == 0).length > 0

  const totalExpand = expanders.map((artifact) => artifact.totalEffect).reduce((partialSum, a) => partialSum + a, 0);
  const totalBoost = Object.values(boosters).filter((booster) => Object.keys(activatedBoosters).includes(booster.name) == false).map((artifact) => artifact.totalEffect).reduce((partialSum, a) => partialSum + a, 0);
  const totalQuota = Object.keys(quotaAmounts).map((token) => quotaAmounts[token] + (totalExpand / (token == 'Stablecoin' || token == 'shLP' ? 1 : token == 'Ether' ? 1000 : 20000)))
  const dispatch = useAppDispatch()

  const getTokenImage = (token: string, inStatistics: boolean) => {
    if (token == 'Stablecoin') {
      return (
        <>
          <img style={{ width: '16px', marginRight: !inStatistics ? '4px' : undefined }} src={`../../assets/coins/shUSDT.svg`} />
          <img style={{ width: '16px', marginRight: !inStatistics ? '4px' : undefined, marginLeft: '-12px' }} src={`../../assets/coins/shDAI.svg`} />
          <img style={{ width: '16px', marginRight: !inStatistics ? '4px' : undefined, marginLeft: '-12px' }} src={`../../assets/coins/shUSDC.svg`} />
        </>
      )
    } else if (token == 'Ether'){
      return (
        <>
          <img style={{ width: '16px', marginRight: !inStatistics ? '4px' : undefined }} src={`../../assets/coins/shwstETH.svg`} />
          <img style={{ width: '16px', marginRight: !inStatistics ? '4px' : undefined, marginLeft: '-12px' }} src={`../../assets/coins/shETH.svg`} />
        </>
      )
    } else {
      return <img style={{ width: '16px', marginRight: !inStatistics ? '4px' : undefined }} src={`../../assets/coins/${token}.svg`} />
    }
  }

  const executeTransaction = () => {
    if (signer) {
      setConfirmDisabled(true)
      setTxState('Pending')

      const ids = Object.keys(activateAmounts).map(artifactID => parseInt(artifactID))
      const amounts = Object.values(activateAmounts).map((amount) => parseInt(amount))

      booty.activateArtifact(ids, amounts).then((response: any) => {

        setTxState('Submitted')

        response.wait().then((result: any) => {
          if (result.status == 1) { //Success

            Object.keys(boosters).map((boosterID) => {
              const booster = boosters[boosterID]
              if(booster.effect.value > 0){ // Don't update for Lucky Chad since we don't know the outcome yet
                const previousDuration = activatedBoosters[booster.name] ?? 0
                const activateAmount = parseInt(activateAmounts[boosterID] ?? '0')
                dispatch(updateBoosts({ address: walletAddress, name: booster.name, value: previousDuration + (booster.effect.duration * activateAmount) }))
              }
            })
      
            if(totalBoost > 0 || randomBoost){
                dispatch(updateBoosts({ address: walletAddress, name: 'Active Boost', value: currentBoost + (totalBoost / 100) }))
                dispatch(clearCurrentPoints({address: walletAddress}))
            }

            if (totalExpand > 0) {
              Object.keys(quotaAmounts).forEach((token, index) => {
                if (token == 'Stablecoin') {
                  dispatch(addQuota({ tokenID: 'shDAI', amount: totalQuota[index] }))
                  dispatch(addQuota({ tokenID: 'shUSDC', amount: totalQuota[index] }))
                  dispatch(addQuota({ tokenID: 'shUSDT', amount: totalQuota[index] }))
                } else if (token == 'shLP') {
                  dispatch(addQuota({ tokenID: 'DAI+USDC', amount: totalQuota[index] }))
                  dispatch(addQuota({ tokenID: 'USDT+USDC', amount: totalQuota[index] }))
                  dispatch(addQuota({ tokenID: 'Stablepool', amount: totalQuota[index] }))
                  dispatch(addQuota({ tokenID: 'ETH+USD', amount: totalQuota[index] }))
                  dispatch(addQuota({ tokenID: 'WBTC+USD', amount: totalQuota[index] }))
                  dispatch(addQuota({ tokenID: 'wstETH+ETH', amount: totalQuota[index] }))
                } else if(token == 'Ether'){
                  dispatch(addQuota({ tokenID: 'shETH', amount: totalQuota[index] }))
                  dispatch(addQuota({ tokenID: 'shwstETH', amount: totalQuota[index] }))
                } else {
                  dispatch(addQuota({ tokenID: token, amount: totalQuota[index] }))
                }
              })
            }

            setTxState('Success')

          } else {
            setTxState('Error')
          }
          setConfirmDisabled(false);
        })
      }).catch(() => {
        setTxState('')
        setConfirmDisabled(false);
      });
    }
  }

  return (
    <StyledModal
      title={txState ? `Activation ${txState}` : 'Confirm Activation'}
      isVisible={visible}
      onClose={() => {
        setActivateDisabled(false)
        setVisible(false)
        if (txState == 'Success') {
          update()
          setActivateAmounts({})
          setTxState('')
        }
      }}
    >
      {(Object.keys(boosters).length > 0 || expanders.length > 0) && txState !== 'Success' && (
        <>
            <AllItemsTitle>All Artifacts</AllItemsTitle>
            <AllItemsCarousel>
            <AllItemsGrid>
                {Object.keys(boosters).map((boosterID) => {
                    const booster = boosters[boosterID]
                    const activateAmount = parseInt(activateAmounts[boosterID] ?? '0')
                    return (
                        <ArtifactView key={booster.name}>
                        <ArtifactViewImage src={`../../assets/booty/${booster.image}.jpg`} />
                        <ArtifactViewTitle>{`${activateAmount}x ${booster.name}`}</ArtifactViewTitle>
                            {Object.keys(activatedBoosters).includes(booster.name) == false && (
                                <ArtifactStatistic style={{marginBottom: '8px'}}>
                                    <img src={`../../assets/icons/boost.svg`} />
                                    <span>{`${booster.totalEffect == 0 ? '???' : '+' + booster.totalEffect + '%'}`}</span>
                                </ArtifactStatistic>
                            )}
                            <ArtifactStatistic>
                                <img src={`../../assets/icons/time.svg`} />
                                <span>{`+${booster.effect.duration * activateAmount}d`}</span>
                            </ArtifactStatistic>
                        </ArtifactView>
                    )
                })}
                {expanders.length > 0 && expanders.map((artifact) => {
                return (
                    <ArtifactView key={artifact.name} >
                    <ArtifactViewImage src={`../../assets/booty/${artifact.image}.jpg`} />
                    <ArtifactViewTitle>{`${activateAmounts[artifact.image] ?? 0}x ${artifact.name}`}</ArtifactViewTitle>
                    <ArtifactStatistics>
                        <ArtifactStatistic>
                            {getTokenImage('shLP', true)}
                            <span>{`+${formatDisplayShorthand(artifact.totalEffect, 0, 1e3)}`}</span>
                        </ArtifactStatistic>
                        <ArtifactStatistic>
                            {getTokenImage('Stablecoin', true)}
                            <span>{`+${formatDisplayShorthand(artifact.totalEffect, 0, 1e3)}`}</span>
                        </ArtifactStatistic>
                        <ArtifactStatistic>
                            {getTokenImage('shWBTC', true)}
                            <span>{`+${artifact.totalEffect / 20000}`}</span>
                        </ArtifactStatistic>
                        <ArtifactStatistic>
                            {getTokenImage('Ether', true)}
                            <span>{`+${artifact.totalEffect / 1000}`}</span>
                        </ArtifactStatistic>
                    </ArtifactStatistics>
                    </ArtifactView>
                )
                })}
            </AllItemsGrid>
            </AllItemsCarousel>
        </>
      )}
      <AllItemsTitle>Summary</AllItemsTitle>
      <SummaryWrapper>
        <SummaryList>
          {Object.keys(boosters).length > 0 && (
            <SummaryView>
              <Column style={{ width: 'auto', rowGap: '8px' }}>
                {Object.values(boosters).filter((booster) => booster.effect.value > 0).map((booster) => 
                    <Label key={booster.name} style={{ color: '#7D7D97', lineHeight: '16px' }}>{`${booster.effect.value}% Boost`}</Label>
                )}
                <Label style={{ color: '#7D7D97', lineHeight: '16px', marginTop: '0px' }}>Active Boost</Label>
              </Column>
              <Column style={{ width: 'auto', marginLeft: 'auto', alignItems: 'flex-end', rowGap: '8px' }}>
                {Object.keys(boosters).filter((id) => boosters[id].effect.value > 0).map((boosterID) => {
                  const booster = boosters[boosterID]
                  const previousDuration = activatedBoosters[booster.name] ?? 0
                  const prevDays = Math.floor(previousDuration)
                  const prevHours = Math.floor((previousDuration - prevDays) * 24)
                  const activateAmount = parseInt(activateAmounts[boosterID] ?? '0')
                  return (
                    <div key={booster.name} style={{ display: 'flex', alignItems: 'center' }} >
                      <img key={booster.name} style={{ width: '16px', margin: '0px 4px 0 8px' }} src={`../../assets/icons/time.svg`} />
                      <Value style={{ lineHeight: '16px' }}>{`${prevDays}d ${prevHours == 0 ? '' : prevHours + 'h'}`}</Value>
                      <Value style={{ color: '#00BDFF', marginLeft: '4px', lineHeight: '16px', fontWeight: 500 }}>{'\u2192'} {`${Math.floor(previousDuration + (booster.effect.duration * activateAmount))}d ${prevHours == 0 ? '' : prevHours + 'h'}`}</Value>
                    </div>
                  )
                })}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                  <img style={{ width: '16px', margin: '0px 4px 0px 8px', marginTop: '0px' }} src={`../../assets/icons/boost.svg`} />
                  <Value style={{ lineHeight: '16px' }}>{`${formatDisplay(currentBoost.toString(), 3)}x`}</Value>
                  {
                    randomBoost ?
                    <Value style={{color: '#00BDFF', marginLeft: '4px', fontWeight: '500', lineHeight: '16px'}}>{'\u2192'} ???</Value> :
                    <Value style={{ color: `${totalBoost > 0 ? '#00BDFF' : '#FFFFFF'}`, marginLeft: '4px', fontWeight: `${totalBoost > 0 ? '500' : '100'}`, lineHeight: '16px' }}>{'\u2192'} {`${formatDisplay((currentBoost + (totalBoost / 100)).toString(), 3)}x`}</Value>
                  }
                </div>
              </Column>
            </SummaryView>
          )}
          {expanders.length > 0 && (
            <SummaryView>
              <Column style={{ width: 'auto', rowGap: '8px' }}>
                {Object.keys(quotaAmounts).map((token) => <Label key={token} style={{ color: '#7D7D97', lineHeight: '16px' }}>{`${token} Quota`}</Label>)}
              </Column>
              <Column style={{ width: 'auto', marginLeft: 'auto', alignItems: 'flex-end', rowGap: '8px' }}>
                {Object.keys(quotaAmounts).map((token, index) => {
                  const numDecimals = token == 'Stablecoin' ? 2 : token == 'Ether' ? 3 : 5
                  return (
                    <div key={token} style={{ display: 'flex', alignItems: 'center' }}>
                      {getTokenImage(token, false)}
                      <Value style={{ lineHeight: '16px' }}>{formatDisplayShorthand(quotaAmounts[token], numDecimals)}</Value>
                      <Value style={{ color: '#00BDFF', marginLeft: '4px', lineHeight: '16px', fontWeight: 500 }}>{'\u2192'} {formatDisplayShorthand(totalQuota[index], numDecimals)}</Value>
                    </div>
                  )
                })}
              </Column>
            </SummaryView>
          )}
        </SummaryList>
      </SummaryWrapper>
      {txState && txState != 'Error' && (
        <CircleContainer>
          {txState == 'Success' ? <ConfirmIcon /> : <Spinner />}
        </CircleContainer>
      )}
      {txState == 'Success' && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <Label style={{ color: '#7D7D97' }}>You activated</Label>
          <ActivatedArtifactsRow>
            {artifactRows.map((artifactRow) => {
              return (
                <Fragment key={artifactRow.toString()}>
                  {artifactRow.map((artifactID: any) =>
                    <Artifact key={artifactID}>
                      <img src={`../../assets/booty/${artifactID}.jpg`} />
                      <ArtifactBalance>{parseInt(activateAmounts[artifactID]) > 99 ? '99+' : activateAmounts[artifactID]}</ArtifactBalance>
                    </Artifact>
                  )}
                </Fragment>
              )
            })}
          </ActivatedArtifactsRow>
        </div>
      )}
      {txState == 'Success' ? (
            <NavButton to={"/points"} onClick={update}>
            {`\u2192 Head to Points`}
            </NavButton>
      ) : (
        txState == 'Error' ? (
          <Error>
            <ErrorIcon />
            Activation Error
          </Error>
        ) : (txState == 'Submitted' ? (
          <Label style={{ margin: '12px auto', color: '#7D7D97' }}>Waiting for blockchain confirmation...</Label>
        ) : (
          <ActionButton onClick={executeTransaction} disabled={confirmDisabled}>
            <ConfirmIcon />
            Confirm Activation
          </ActionButton>
        ))
      )}
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  height: fit-content;
  max-width: 724px;

  ${ModalContent} {
    overflow: unset;
  }

  ${Media.mobile} {
    height: 95%;
    max-width: 100%;
    margin-top: 5.5%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`;

const AllItemsList = styled.p`
  margin-top: 8px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: #7D7D97;
`

const AllItemsTitle = styled.h5`
  margin: 12px 0 12px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: #ffffff;
`

const AllItemsCarousel = styled.div`
  display: flex;
  width: calc(100% + 48px);
  margin: 0 -24px;
  overflow: scroll;
  scrollbar-width: none;

  &:before,
  &:after {
    content: '';
    display: block;
    min-width: 16px;
    max-width: 16px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  ${Media.mobile} {
    width: calc(100% + 32px);
    margin: 0 -16px;
  }
`

const AllItemsGrid = styled.div`
  display: flex;
  column-gap: 8px;
`

const SummaryWrapper = styled.div`
  width: 100%;
  max-width: 100%;
`

const SummaryList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  width: 100%;
  max-width: 100%;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const ArtifactView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 168px;
  height: 168px;
  padding: 12px;
  border: 1px solid #292941;
  border-radius: 16px;
  background-color: #1E2239;
  overflow: hidden;
`

const ArtifactViewImage = styled.img`
  display: block;
  width: 64px;
  height: 64px;
  border-radius: 8px;
  object-fit: cover;
  overflow: hidden;
`

const ArtifactViewTitle = styled.h4`
  margin: 8px 0 8px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
`

const ArtifactStatistics = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 4px;
  row-gap: 8px;
  width: 100%;
  max-width: 100%;
`

const ArtifactStatistic = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  column-gap: 4px;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  color: #ffffff;
  overflow: hidden;

  img {
    display: block;
    width: 16px;
    height: 16px;
  }

  span {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const ActivatedArtifactsRow = styled.div`
  display: flex;
  width: fit-content;
  max-width: 100%;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px auto 0;
  justify-content: center;
`

const SummaryView = styled.div`
  display: flex;
  justify-content: space-between;
`

const Amount = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  img {
    width: 48px;
    border-radius: 14px;
    border: 2px solid #1E2239;
    margin: 0 8px 0 8px;
  } 
`

const TokenContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-weight: 10;
  font-size: 20px;
  letter-spacing: -0.03em;
  color: #FFFFFF;
`;

const Label = styled.p<{ total?: boolean }>`
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  letter-spacing: -0.02em;
  color: ${({ total }) => total ? '#00BDFF' : '#FFFFFF'};
`;

const CircleContainer = styled.div`
  width: 74px;
  height: 74px;
  margin: 16px auto;
  color: #00BDFF;

  ${Media.smallMobile}{
    width: 56px;
    height: 56px;
  }
`

const Value = styled(Label)`
  font-weight: 100;
  line-height: 24px;
`

const Artifact = styled.div`
  width: 64px;
  height: 64px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    border-radius: 16px;
    border: solid 2px #1E2239;
  } 

  ${Media.smallMobile}{
    width: 48px;
    height: 48px;
  }
`

const ArtifactBalance = styled.p`
  position: absolute;
  min-width: 24px;
  min-height: 24px;
  font-weight: 10;
  font-size: 10px;
  line-height: 24px;
  text-align: center;
  margin-top: 34px;
  margin-left: 34px;

  border-radius: 12px;
  background: #00BDFF;
  color: #1E2239;
`

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 264px;
  height: 76px;
  margin: 24px auto 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #0a0e27;
  background: linear-gradient(90.44deg, #37dcf2 0.87%, #07c0fb 100%);
  border-radius: 16px;

  svg {
    height: 28px;
    width: 28px;
    margin-right: 8px;
    color: #464659;
  }

  &:not(:disabled) svg path {
    fill: #151530;
  }

  &:disabled {
    background: #0a0e27;
    color: #464659;
    border: solid 2px #464659;
  }

  ${Media.tablet} {
    height: 66px;
    margin-top: auto;
  }
`;

const Error = styled(ActionButton)`
    background: linear-gradient(90.44deg, #fb0740 0.87%, #fb0707 100%);
    pointer-events: none;
`

const NavButton = styled(NavLink)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 264px;
    height: 76px;
    margin: 24px auto 0;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #0a0e27;
    background: linear-gradient(90.44deg, #37dcf2 0.87%, #07c0fb 100%);
    border-radius: 16px;

    svg {
        height: 28px;
        width: 28px;
        margin-right: 8px;
        color: #464659;
    }

    &:not(:disabled) svg path {
        fill: #151530;
    }

    &:disabled {
        background: #0a0e27;
        color: #464659;
        border: solid 2px #464659;
    }
    
    ${Media.tablet} {
        height: 66px;
        margin: 32px auto;
    }
`